import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './fitting.module.scss'
import { Card, CardBody } from '../../../../../components/card'
import { ReactComponent as Seb } from '../../../../../sections/providers/logos/seb.svg'
import { ReactComponent as Swedbank } from '../../../../../sections/providers/logos/swedbank.svg'
import { ReactComponent as Handelsbanken } from '../../../../../sections/providers/logos/handelsbanken.svg'

export default function Fitting() {
  const providers = [Handelsbanken, Seb, Swedbank]

  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <FormattedMessage
            defaultMessage="<i>“</i> Att vi har sänkt våra kostnader för redovisningstjänster med 84% är helt fantastiskt.<i>”</i>"
            id="landing-pages.signup.fitting.heading"
            tagName="h2"
            values={{
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              i: (...chunks: any) => <i>{chunks}</i>,
            }}
          />
          <FormattedMessage
            defaultMessage="<b>Georgios Karpathakis</b>, Underbara ADHD"
            id="landing-pages.signup.fitting.lede"
            tagName="p"
            values={{
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              b: (...chunks: any) => <b>{chunks}</b>,
            }}
          />

          <Card className={styles.providersContainer}>
            <CardBody className={styles.providersBody}>
              <FormattedMessage
                defaultMessage="Dooer fungerar med följande banker:"
                id="landing-pages.fitting.banks.heading"
                tagName="strong"
              />
              <div className={styles.providers}>
                {providers.map((Provider, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Provider key={i} />
                ))}
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  )
}
